import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {TextInput, Button, SelectSearch, Select} from 'advenio-components'
import { Form } from 'formsy-react'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import styled from 'styled-components'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'

const Container = styled.div`
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`

class AddParent extends Component {
  state = {
    options: [],
  }

  componentDidMount() {
    const options = [
      {
        label: 'Sin Empresa',
        value: '',
        id: 0,
      },
    ]

    this.props.companies.map((company) => {
      options.push({
        label: company.name,
        value: company.id,
        id: company.id,
      })
    })

    this.setState({ options })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.loading && !nextProps.loading && nextProps.error === null) {
      this.props.closeModal()
    }
  }

  submit = (data) => {
    const { studentId, createParent } = this.props
    createParent(studentId, data)
  }

  formatOptions = (r) => r.map(relation => ({
    id: relation.id,
    label: relation.translations.es,
    value: relation.id
  }))
  render() {
    const {closeModal, loading, relations} = this.props
    const optionsRelations = this.formatOptions(relations)
    return (
      <Container>
        <Form style={{width: '100%'}}
              ref={(form) => {
                this.form = form
              }}
              onValidSubmit={this.submit}
        >
          <Row>
            <Col xs={12} sm={12} md={4}>
              <TextInput name="first_name" label="Nombre" required />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <TextInput name="last_name_paternal" label="Apellido paterno" required />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <TextInput name="last_name_maternal" label="Apellido materno" />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6} md={6} lg={4}>
              <TextInput name="email" label="Email" type="email" required />
            </Col>
            <Col xs={12} sm={6} md={6} lg={4}>
              <Select
                name="relation_id"
                label="Relación"
                required
                placeholder="Seleccione Relación"
                options={optionsRelations}
                // emptyElement
                hideEmptyHelpBlock
              />
            </Col>
            <Col xs={12} sm={6} md={6} lg={4}>
              <SelectSearch
                name="company_id"
                label="Empresa"
                options={this.state.options}
                placeholder="Seleccione Empresa"
              />
            </Col>
          </Row>
          <Row>
            <div style={{ textAlign: 'right', width: '100%'}}>
              <Button onClick={closeModal} marginRight="0">
                Cancelar
              </Button>
              <Button primary type="submit" loading={loading} marginRight="0">
                Guardar
              </Button>
            </div>
          </Row>
        </Form>
      </Container>
    )
  }
}

AddParent.propTypes = {
  /** Loading flag */
  loading: PropTypes.bool.isRequired,
  /** Student Id */
  studentId: PropTypes.number.isRequired,
  /** Error status info */
  error: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string,
  ]),
  /** Companies List */
  companies: PropTypes.array.isRequired,

  /** Callback function to be fired after closing the modal */
  closeModal: PropTypes.func.isRequired,
  /** Attempt to store the parent in the API */
  createParent: PropTypes.func.isRequired,
}

AddParent.defaultProps = {
  error: null,
}

const mapStateToProps = state => ({
  loading: state.classrooms.createParent.fetching,
  error: state.classrooms.createParent.error,
  companies: state.companies.get.results,
  relations: state.relations.get.results,
})

const mapDispatchToProps = dispatch => ({
  createParent: (studentId, info) =>
    dispatch(ClassroomActions.createParentRequest(studentId, info)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddParent)



// WEBPACK FOOTER //
// ./src/Components/ModalContainer/AddParent.jsx